import Alert from '@mui/material/Alert';
import { getCorporationRetrieveStatus } from './portalFormValidation';

// เดิม ternary chain (severity error/warning/success) ซ้ำกันเป๊ะทั้งใน
// CreatePortal.jsx และ EditPortal.jsx และใช้ .some() ที่มี bug เดียวกันกับปุ่มบันทึก
// (ดูคำอธิบายใน getCorporationRetrieveStatus)
const STATUS_MESSAGE = {
    missing: { severity: 'error', text: 'กรุณาเลือกวิธีการดึงข้อมูลจากฐานข้อมูลที่ทางองค์กรนำเข้าระบบ UM' },
    incomplete: { severity: 'warning', text: 'กรุณาเลือกวิธีการดึงข้อมูลจากฐานข้อมูลที่ทางองค์กรนำเข้าระบบ UM เพิ่มเติม' },
    complete: { severity: 'success', text: 'กรุณาเลือกวิธีการดึงข้อมูลจากฐานข้อมูลที่ทางองค์กรนำเข้าระบบ UM' },
};

const CorporationRetrieveStatusAlert = ({ retrieve, style }) => {
    const status = getCorporationRetrieveStatus(retrieve);
    const { severity, text } = STATUS_MESSAGE[status];
    return <Alert severity={severity} style={style}>{text}</Alert>;
};

export default CorporationRetrieveStatusAlert;